import React from 'react'

export const Defalut = () => {
    return (
        <div className="text-5xl text-[#666] font-bold w-screen h-[80vh] flex justify-center items-center">
            Select the type of Masposting
        </div>
    )
}
